import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";

import Divider from "../../../../components/ui/divider/Divider";
import IntroGraphic from "../../../../assets/graphics/Intro";
import { SectionProps } from "../../index";

import useStyles from "./style";

export default function Intro(props: SectionProps) {
  const { ref, inView } = useInView({
    threshold: 0.2,
  });

  useEffect(() => {
    props.showChange(props.index, inView);
  }, [inView]);

  const classes = useStyles();

  return (
    <div ref={ref} className={classes.root}>
      <div className={classes.wrapper}>
        {inView && (
          <div className={classes.content}>
            <h1
              style={{ whiteSpace: "nowrap" as "nowrap" }}
              className={classes.title}
            >
              Hello World!
            </h1>
            <h1 className={classes.title}>I'm Enes</h1>

            <Divider />

            <h2 className={classes.subTitle}>Aspiring Developer /</h2>

            <h2 className={classes.subTitleSecond}>Computer Science Student</h2>
          </div>
        )}

        <div className={classes.graphicWrapper}>
          {inView && <IntroGraphic />}
        </div>
      </div>
    </div>
  );
}
